//
//
//
//
//
//
//

export default {
  name: "Shuffle",
  props: ['tag']
};
